import { render, staticRenderFns } from "./Ticket-card.vue?vue&type=template&id=1d296e02&scoped=true"
import script from "./Ticket-card.vue?vue&type=script&lang=js"
export * from "./Ticket-card.vue?vue&type=script&lang=js"
import style0 from "./Ticket-card.vue?vue&type=style&index=0&id=1d296e02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d296e02",
  null
  
)

export default component.exports